import * as csv from 'csv-parse/lib/sync';
// import * as plotly from 'plotly.js-dist';
import 'regenerator-runtime/runtime';
import katex from 'katex';
import {Buffer} from 'buffer';

window.Buffer = Buffer;
const KELVIN_OFFSET = 273.16
const kISMinTemp = 203.16;
const kISMaxTemp = 2273.16;
const kISStep = 10;


function isNullEquation(equation) {
    return equation[6].split('<=>')[0].trim() == "null" && equation[6].split('<=>')[1].trim() == "null"
}

function getIndexImage(tab) {
    let cas = 0;
    let i = 0;

    for (let elem in tab) {
        if (tab[elem] != 0) {
            cas = i;
            break;
        } else {
            i += 1;
        }
    }
    return cas
}

function toKelvin(temperature) {
    return temperature + KELVIN_OFFSET;
}

function toCelcius(temperature) {
    return temperature - KELVIN_OFFSET;
}

function getExactTemperature(equationA, equationB, alpha, estimatedTemp) {
    let relax = 1.0;
    let deltaT = 1.0;
    let tori = 0.0;
    
    let et = estimatedTemp;
    
    while (deltaT > 0.01) {
        let lnAlpha = calculate(equationA, equationB, alpha, et);
        tori = estimatedTemp;
        et += 1;
        let lnAlphaP1 = calculate(equationA, equationB, alpha, et);
        et -= 2;
        let lnAlphaM1 = calculate(equationA, equationB, alpha, et);
        
        deltaT = -2.0 / (lnAlphaP1 - lnAlphaM1) * lnAlpha;
    }
    
    return deltaT * relax + tori;
}

function place_right_equation(equation, eqLetter) {
    const lnAImage = [
        6,
        4,
        3,
        2,
        1
    ];

    const a = parseFloat(equation[0])
    const b = parseFloat(equation[1])
    const c = parseFloat(equation[2])
    const d = parseFloat(equation[3])
    const e = parseFloat(equation[4])
    const f = parseFloat(equation[5])

    const index = getIndexImage([a, b, c, d, e, f]);
    const lnAlphaImage = lnAImage[index];
    const elem = document.getElementById("equationLatex" + eqLetter);
    switch (lnAlphaImage) {
        case 1:
            katex.render("1000 \\, ln \\alpha = " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 2:
            katex.render("1000 \\, ln \\alpha = " + equation[3] + "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 3:
            katex.render("1000 \\, ln \\alpha = " + equation[2] + "\\frac{10^9}{T^3} + " + equation[3] +  "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 4:
            katex.render("1000 \\, ln \\alpha = " + equation[1] + "\\frac{10^{12}}{T^4} + " + equation[2] + "\\frac{10^9}{T^3} + " + equation[3] +  "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 6:
            katex.render("1000 \\, ln \\alpha = " + equation[0] + "\\frac{10^{18}}{T^6} + " + equation[1] + "\\frac{10^{12}}{T^4} + " + equation[2] + "\\frac{10^9}{T^3} + " + equation[3] +  "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
    }
    var testElements = document.getElementsByClassName('katex-html');
    for (let item of testElements) {
        item.parentNode.removeChild(item);
    }
}

async function placeReference(eqLetter, ref1, ref2) {
    const response = await fetch('https://alphadelta.ggl.ulaval.ca/data/refiso.prn', { method: 'GET'})
    .catch(error => {
        console.log(error);
    });
    const fileContent = await response.text();
    const fileParsed = fileContent.split("\n");
    if (ref1 >= 0) {
        document.getElementById("references" + eqLetter).innerHTML = fileParsed[ref1] + "<br><br>";
    }
    if (ref2 >= 0) {
        document.getElementById("references" + eqLetter).innerHTML += fileParsed[ref2];
    }
}

function calculate(equationA, equationB, alpha, temperature) {
    let diffA = parseFloat(equationA[0]) - parseFloat(equationB[0]);
    let diffB = parseFloat(equationA[1]) - parseFloat(equationB[1]);
    let diffC = parseFloat(equationA[2]) - parseFloat(equationB[2]);
    let diffD = parseFloat(equationA[3]) - parseFloat(equationB[3]);
    let diffE = parseFloat(equationA[4]) - parseFloat(equationB[4]);
    let diffF = parseFloat(equationA[5]) - parseFloat(equationB[5]);
    
    let termeA = diffA * Math.pow(10, 18) / Math.pow(temperature, 6);
    let termeB = diffB * Math.pow(10, 12) / Math.pow(temperature, 4);
    let termeC = diffC * Math.pow(10, 9) / Math.pow(temperature, 3);
    let termeD = diffD * Math.pow(10, 6) / Math.pow(temperature, 2);
    let termeE = diffE * Math.pow(10, 3) / temperature;
    
    return termeA + termeB + termeC + termeD + termeE + diffF - alpha;
}

function getRoots(equationA, equationB, alpha) {
    let temperatures = [];
    
    let lnAlpha = 0.0;
    let previousLnAlpha = 0.0;
    
    for(let i = kISMinTemp; i < kISMaxTemp; i += kISStep) {
        previousLnAlpha = lnAlpha;
        lnAlpha = calculate(equationA, equationB, alpha, i);
        if(lnAlpha * previousLnAlpha < 0.0) {
            let temperature = getExactTemperature(equationA, equationB, alpha, i);
            temperatures.push(temperature);
        }
    }
    
    return temperatures;
}

async function read_csv() {
    
    const response = await fetch('https://alphadelta.ggl.ulaval.ca/data/rres.csv', { method: 'GET'})
    .catch(error => {
        console.log(error);
    });
    // renderKatex()
    const fileContent = await response.text();
    // break the textblock into an array of lines
    let contentTab = fileContent.split('\n');
    // remove one line, starting at the first position
    contentTab.splice(0,1);
    // join the array back into a single string
    let contentWithoutFirstLine = contentTab.join('\n');
    return csv.parse(contentWithoutFirstLine, {delimiter: ";"});
}

async function generateGraph(equationA, equationB, temperature) {
    const xlabel = '$10^6/T^2(K)$';
    const ylabel = '$1000lnα_'+ '{'+ equationA[6].split('<=>')[0] + '-' + equationB[6].split('<=>')[0] + '}$'

    let tempList = [];
    let vallist = [];

    for (let t = kISMinTemp; t < kISMaxTemp; t += kISStep) {
        tempList.push(t);
    }

    tempList.forEach(t => {
        vallist.push(calculate(equationA, equationB, 0, t));
    });

    for (let i = 0; i < tempList.length; i++) {
        tempList[i] = 1000000.0 / (tempList[i] * tempList[i]);
    }
    let chartShapes = [];
    let chartAnnotations = []
    let ymax = Math.max.apply(Math, vallist);
    const roots = getRoots(equationA, equationB, temperature);

    if (roots.length == 0) {
        const elem = document.getElementById("no_roots");
        const elem2 = document.getElementById("no_roots2");
        katex.render("\\text{La valeur  ne recoupe pas la courbe l000 ln (A-B) vs }\\frac{10^6}{T^2} \\text{pour la plage de température. Vérifiez l'hypothèse d'équilibre isotopique.}", elem, {throwOnError: false});
        var katexElement = document.getElementsByClassName('katex-html');
        for (let item of katexElement) {
            item.parentNode.removeChild(item);
        }
        katex.render("\\text{The  value does not intercept the l000 ln (A-B) vs }\\frac{10^6}{T^2}\\text{ curve for the temperature range. Verify the isotope equilibrium hypothesis.}", elem2, {throwOnError: false});
        var katexElement = document.getElementsByClassName('katex-html');
        for (let item of katexElement) {
            item.parentNode.removeChild(item);
        }
        document.getElementById("tempValue").innerHTML = "Aucun résultat pour / No result for";
        document.getElementById("tInterval").innerHTML = "-70 < T < 2000<sup>o</sup>C</b>";
    }

    let root_loop = 0;
    roots.forEach(root => {
        const root_temperature = toCelcius(root);
        const verticalPosition = 1000000.0 / (root * root);
        const verticalLine = {
            type: 'line',
            yref: 'paper',
            x0: verticalPosition,
            y0: 0,
            x1: verticalPosition,
            y1: 1,
            line:{
                color: 'rgb(0, 128, 0)',
                width: 2,
            }
        }

        const label = {
            x: verticalPosition,
            y: ymax + root_loop * 6,
            text: root_temperature.toFixed(1),
            showarrow: false,
            align: "right",
            xanchor: 'left',
        }

        chartShapes.push(verticalLine);
        chartAnnotations.push(label);
        document.getElementById("tempValue").innerHTML += "<center><h2><b> T = " + root_temperature.toFixed(1) + " <sup>o</sup>C</b></h2></center>";

        root_loop += 1;
    });

    chartAnnotations.push({
        xref: 'paper',
        yref: 'paper',
        x: 0,
        xanchor: 'left',
        y: 0,
        yshift: -50,
        font: {size: 10},
        yanchor: 'top',
        text: 'http://alphadelta.ggl.ulaval.ca',
        showarrow: false
    
    });

    chartAnnotations.push({
        x: Math.max.apply(Math, tempList),
        y: temperature,
        text: temperature.toFixed(1),
        showarrow: false,
        align: "right",
        anchor: 'bottom',
        yshift: 10
    });

    chartShapes.push(
        {
            type: 'line',
            xref: 'paper',
            x0: 0,
            y0: temperature,
            x1: 1,
            y1: temperature,
            line:{
                color: 'rgb(255, 0, 0)',
                width: 2,
            }
        },
    );

    const trace = {
        x: tempList,
        y: vallist,
        type: 'lines',
        with: 2,
        line: {
            color: 'rgb(5, 102, 166)',
            width: 2,
        }
    }

    const layout = {
        xaxis: {
            linecolor: 'black',
            linewidth: 2,
            mirror: true,
            zeroline:false,
            title: xlabel
        },
        yaxis: {
            linecolor: 'black',
            linewidth: 2,
            mirror: true,
            zeroline:false,
            title: ylabel
        },
        font: {
            size: 16
        },
        annotations: chartAnnotations,
        shapes: chartShapes,
        title: '<b>T (C)<b>',
    }

    await Plotly.newPlot('chart', [trace], layout);
}

async function main () {
    const params = new URLSearchParams(location.search);
    const temperature = parseFloat(params.get("-a").replace(",", "."));
    const equationIndexA = parseFloat(params.get("-e1"));
    const equationIndexB = parseFloat(params.get("-e2"));
    
    if (params.get("-a") == "") {
        document.getElementById("errorId").innerHTML = "<b>Vous n'avez pas inscrit une valeur pour (A-B), reculez </br>\
        You did not enter a (A-B) value, go back</b>";
        return;
    }
    else if (params.get("-e1") == null) {
        document.getElementById("errorId").innerHTML = "<b>Equation A non sélectionnée, reculez</br>\
        Equation A not selected, go back</b>";
        return;
    }else if (params.get("-e2") == null) {
        document.getElementById("errorId").innerHTML = "<b>Equation B non sélectionnée, reculez</br>\
        Equation B not selected, go back</b>";
        return;
    }

    const equations = await read_csv();
    const equationA = equations[equationIndexA];
    const equationB = equations[equationIndexB];

    if(!isNullEquation(equationA) && !isNullEquation(equationB)) {
        if (equationA[6].split("<=>")[1].trim() != equationB[6].split("<=>")[1].trim()) {
                document.getElementById("errorId").innerHTML = "<b>Le dénominateur des 2 équations est différent, reculez</br>\
                The denominator for the equations is different, go back </b>";
                return;
            }
    }

    document.getElementById("percentValue").innerHTML = temperature.toFixed(1);
    place_right_equation(equationA, "A");
    place_right_equation(equationB, "B");
    await generateGraph(equationA, equationB, temperature);
    await placeReference("A", parseInt(equationA[9] - 1), parseInt(equationA[10] - 1));
    await placeReference("B", parseInt(equationB[9] - 1), parseInt(equationB[10] - 1));
    document.getElementById("equationNameA").innerHTML = " " + equationA[6] + "; " + equationA[8];
    document.getElementById("equationNameB").innerHTML = " " + equationB[6] + "; " + equationB[8];
    document.getElementById("equationPrincipalName").innerHTML = " " + equationA[6].split("<=>")[0] + " - " + equationB[6].split("<=>")[0];
}

let promise = new Promise(function(resolve, reject) {
    main();
    resolve();
  });

  promise.then(() => {
    console.log("computed");
})